import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import ProductSale from './productSale'

const StyledRoot = styled.div(({ theme: { spaces } }) => ({
  lineHeight: 1.2,
  paddingBottom: `${spaces.default * 0.5}px`,
  '& > div:not(:last-child)': {
    marginBottom: spaces.default * 0.4,
  },
}))

const StyledPriceWrapper = styled.div(({ theme: { spaces, twoRowsLimit }, previewMode }) => ({
  fontWeight: 800,
  '& > span:not(:last-child)': {
    marginRight: spaces.default / 3,
  },
  ...(previewMode ? twoRowsLimit : {}),
}))

const StyledPrice = styled.span(({ theme: { fontSize }, previewMode }) => ({
  display: 'inline-block',
  fontSize: previewMode ? fontSize * 0.875 : fontSize * 1.5,
}))

const StyledPreSuffixPrice = styled.span(({ theme: { fontSize } }) => ({
  fontSize: fontSize * 0.875,
}))

const StyledDiscountedPrice = styled.span(({ theme: { colors, fontSize } }) => ({
  textDecoration: 'line-through',
  fontWeight: 400,
  color: colors.mid_grey,
  fontSize: fontSize * 0.875,
}))

const ProductPrices = ({
  price, prefixPrice, suffixPrice, discountedPrice, sale, previewMode,
}) => {
  if (
    !prefixPrice
    && !price
    && !suffixPrice
    && !discountedPrice
    && !price
    && !sale
  ) {
    return null
  }

  return (
    <StyledRoot>
      <StyledPriceWrapper previewMode={previewMode}>
        {prefixPrice ? <StyledPreSuffixPrice>{prefixPrice}</StyledPreSuffixPrice> : null}
        {price ? <StyledPrice previewMode={previewMode} data-test="ProductPrice">{price}</StyledPrice> : null}
        {suffixPrice ? <StyledPreSuffixPrice>{suffixPrice}</StyledPreSuffixPrice> : null}
      </StyledPriceWrapper>
      <StyledPriceWrapper>
        {
          (price && discountedPrice) && (
            <StyledDiscountedPrice data-test="ProductDiscountedPrice">
                {discountedPrice}
            </StyledDiscountedPrice>
          )
        }
        <ProductSale sale={sale} />
      </StyledPriceWrapper>
    </StyledRoot>
  )
}

ProductPrices.propTypes = {
  price: PropTypes.string,
  prefixPrice: PropTypes.string,
  suffixPrice: PropTypes.string,
  discountedPrice: PropTypes.string,
  sale: PropTypes.string,
  previewMode: PropTypes.bool,
}

ProductPrices.defaultProps = {
  price: '',
  prefixPrice: '',
  suffixPrice: '',
  discountedPrice: '',
  sale: '',
  previewMode: false,
}

ProductPrices.displayName = 'ProductPrices'
ProductPrices.whyDidYouRender = true

export default React.memo(ProductPrices)
